function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 6.5A1.5 1.5 0 011.5 5h27a1.5 1.5 0 010 3h-27A1.5 1.5 0 010 6.5zM1.5 14a1.5 1.5 0 000 3h27a1.5 1.5 0 000-3h-27zm0 9a1.5 1.5 0 000 3h27a1.5 1.5 0 000-3h-27z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "5",
  width: "30",
  height: "21"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 6.5A1.5 1.5 0 011.5 5h27a1.5 1.5 0 010 3h-27A1.5 1.5 0 010 6.5zM1.5 14a1.5 1.5 0 000 3h27a1.5 1.5 0 000-3h-27zm0 9a1.5 1.5 0 000 3h27a1.5 1.5 0 000-3h-27z",
  fill: "currentColor"
}))));